import PropTypes from 'prop-types';
import { Link } from 'react-router';
import { PiListPlusFill } from 'react-icons/pi';

import { Button } from '#/modules/commonComponents/button';

function ListAddButton({ to, disabled = false }) {
  const content = (
    <>
      <PiListPlusFill size={20} aria-hidden />
      新增
    </>
  );

  return (
    <Button type="button" asChild={!disabled} disabled={disabled}>
      {!disabled ? (
        <Link to={to}>{content}</Link>
      ) : (
        content
      )}
    </Button>
  );
}

ListAddButton.propTypes = {
  to: PropTypes.string,
  disabled: PropTypes.bool,
};

export default ListAddButton;
